import { httpClient } from './http-client';
import type { ApiResponse, PaginatedResponse } from './api.types';
import type { Establecimiento } from '../../modelos/Auth';

export interface CreateEstablecimientoDTO {
  codigo: string;
  nombre: string;
  direccion?: string;
  codigoDistrito?: string;
  distrito?: string;
  codigoProvincia?: string;
  provincia?: string;
  codigoDepartamento?: string;
  departamento?: string;
  codigoPostal?: string;
  telefono?: string;
  correo?: string;
  esPrincipal?: boolean;
  esActivo?: boolean;
}

export interface UpdateEstablecimientoDTO extends Partial<CreateEstablecimientoDTO> {
  id: string;
}

export const establecimientosService = {
  getAll: (params?: { page?: number; per_page?: number; search?: string }): Promise<ApiResponse<PaginatedResponse<Establecimiento>>> => {
    return httpClient.get('/establecimientos', params);
  },

  getById: (id: string): Promise<ApiResponse<Establecimiento>> => {
    return httpClient.get(`/establecimientos/${id}`);
  },

  create: (data: CreateEstablecimientoDTO): Promise<ApiResponse<Establecimiento>> => {
    return httpClient.post('/establecimientos', data);
  },

  update: (data: UpdateEstablecimientoDTO): Promise<ApiResponse<Establecimiento>> => {
    return httpClient.put(`/establecimientos/${data.id}`, data);
  },

  delete: (id: string): Promise<ApiResponse<void>> => {
    return httpClient.delete(`/establecimientos/${id}`);
  },

  toggleStatus: (id: string): Promise<ApiResponse<Establecimiento>> => {
    return httpClient.patch(`/establecimientos/${id}/toggle-status`);
  },

  getByEmpresa: (): Promise<ApiResponse<Establecimiento[]>> => {
    return httpClient.get('/establecimientos');
  },
};
